import React, { Component } from 'react'
import styles from '../css/UserList.module.css';

class UserList extends Component {
    render() {

        const { users } = this.props;
        return(
            <div className={styles.module}>
                <table className={styles.table}>
                    <thead>
                        <tr>
                            <th>User</th>
                            <th>Project</th>
                        </tr>
                    </thead>
                    <tbody>
                        {users.map((user, i) => (
                            <tr key={i}>
                                <td>{user.uid}</td>
                                <td>{user.project}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        )
    }


}

export default UserList;